import React from 'react';
import { compose, mergeDeepRight } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

import Tabs, { Tab } from '../../generic/TabList';
import styleTabs from '../../generic/TabList/tabList.js';
import Image from '@synergycms_core/components/generic/Image';
import Slide, { SlideItem, ButtonSlide } from '@synergycms_core/components/generic/Slide';
import styleFile from './ModalMedia.js';
import Modal from '@synergycms_core/components/generic/Modal';
import { RichText, Button } from '@synergycms_core/components/generic/';
import Icon from '@synergycms_core/components/generic/Icon';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const HotelInfoFrame = props => (
  <iframe title={props.title} className={props.frameStyle} src={props.src} frameBorder="0" />
);

/*
const TabTitlePhotos = props => (
  <span onClick={props.changeSelectedTab('photo')}>
    <Icon unicodeContent={'e14c'} innerStyle={['mainColor', 'size18', 'iconTab']} />
    <RichText
      plural={props.totalPhotos}
      text={'_%foto%_'}
      translate={true}
      innerStyle={['roboto16Black400', props.selectedTab === 'photo' ? 'mainColor' : 'white', 'uppercase']}
    />
    <RichText text={' (' + props.activePhoto + ' / ' + props.totalPhotos + ')'} innerStyle={[props.classes.counterSpan,'roboto16SoftGray400']} />
  </span>
);*/

const TabTitleVideo = props => (
  <span onClick={props.changeSelectedTab('video')}>
    <Icon unicodeContent={'e14e'} innerStyle={['mainColor', 'size18', 'iconTab']} />
    <RichText
      text={'_%video%_'}
      translate={true}
      innerStyle={['roboto16Black400', props.selectedTab === 'video' ? 'mainColor' : 'white', 'uppercase']}
    />
  </span>
);

const TabTitle360 = props => (
  <span onClick={props.changeSelectedTab('360')}>
    <Icon unicodeContent={'e147'} innerStyle={['mainColor', 'size18', 'iconTab']} />
    <RichText
      text={'360º'}
      innerStyle={['roboto16Black400', props.selectedTab === '360' ? 'mainColor' : 'white', 'uppercase']}
    />
  </span>
);

const TooltipMedia = class TooltipMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPhoto: 0,
      selectedTab: 'photo',
      width:null,
    };
    this.widthRef = React.createRef();
  }

  propagateSelectedPhoto = key => {
    this.setState(state =>
      mergeDeepRight(state, {
        selectedPhoto: key
      })
    );
  };

  changeSelectedTab = key => e => {
    this.setState(state =>
      mergeDeepRight(state, {
        selectedTab: key
      })
    );
  };

  componentDidMount() {
    this.getWidthComponent();
  }

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({ 
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth)
      });
    }
  };

  render() {
    const config = this.props.config;
    const videoList = config.videoEntity || config.mediaEntity;
    const wideViewEntity = config.wideViewEntity || config.mediaEntity;
    const classes = this.props.classes;
    const resizableImages = this.props.resizableImages && this.state.width ? this.state.width : '';

    return (
      <div className={classes.modalTabsList} ref={this.widthRef}>
        <div onClick={e => e.stopPropagation()} className={classes.headerModal}>
          <RichText innerStyle={classes.modalTitle} text={config.mediaEntity.get('name')} />
        </div>
        <Tabs titleBlockStyle={classes.titleListBlock} innerStyle={classes.tabComponent} contentBlockStyle={classes.contentTabStyle}>
          {(config.mediaEntity.get('default_photo') || config.mediaEntity.get('photo')) && (
            <Tab
              contentKey={1}
              // tabTitle={
              //   <TabTitlePhotos
              //     totalPhotos={config.mediaEntity.get('photos').size}
              //     activePhoto={this.state.selectedPhoto + 1}
              //     changeSelectedTab={this.changeSelectedTab}
              //     selectedTab={this.state.selectedTab}
              //     classes={classes}
              //   />
              // }
              key={1}>
              <div className={classes.gallery} onClick={e => e.stopPropagation()} >
                <Slide propagateSelectedKey={this.propagateSelectedPhoto} wrapperContent={classes.slideModalMedia} transitionSpeed={300}>
                  {config.mediaEntity.get('photos').map((urlImage, i) => {
                    return (
                      <SlideItem key={urlImage} contentKey={urlImage}>
                        <Image
                          innerStyle={classes.backgroundModalImage}
                          noDefaultStyle={true}
                          backgroundImage={urlImage + resizableImages}
                          alt={[config.mediaEntity.get('name'), '_', i + 1].join('')}
                        />
                      </SlideItem>
                    );
                  })}
                  <div className={classes.wrapperButtons}>
                    <ButtonSlide
                      icon={{
                        unicodeContent: 'e000',
                        innerStyle: ['size13']
                      }}
                      
                      direction={'next'}
                      innerStyle={classes.topButton}
                    />
                    {config.mediaEntity.get('photos').size > 1 && 
                    config.langCode !== 'ar' ? 
                    <RichText text={' (' + (this.state.selectedPhoto + 1) + '/' + config.mediaEntity.get('photos').size + ')'} innerStyle={[classes.counterPhotoText,'roboto16SoftGray400']} /> : 
                    <RichText text={' (' + config.mediaEntity.get('photos').size + '/' + (this.state.selectedPhoto + 1) + ')'} innerStyle={[classes.counterPhotoText,'roboto16SoftGray400']} />
                    }
                    <ButtonSlide
                      icon={{
                        content: '\\',
                        innerStyle: ['size13']
                      }}
                      direction={'prev'}
                      innerStyle={classes.botButton}
                    />
                  </div>
                </Slide>
              </div>
            </Tab>
          )}
          {videoList.get('default_video') && (
            <Tab
              contentKey={2}
              tabTitle={
                <TabTitleVideo changeSelectedTab={this.changeSelectedTab} selectedTab={this.state.selectedTab} />
              }
              key={2}>
              <div className={classes.gallery}>
                <HotelInfoFrame
                  title={'Hotel Info'}
                  src={config.mediaEntity.get('default_video')}
                  frameStyle={classes.modalIFrame}
                />
              </div>
            </Tab>
          )}
          {wideViewEntity.get('wide_view_url') && (
            <Tab
              contentKey={3}
              tabTitle={<TabTitle360 changeSelectedTab={this.changeSelectedTab} selectedTab={this.state.selectedTab} />}
              key={3}>
              <div className={classes.gallery}>
                <HotelInfoFrame
                  title={'Hotel Wide View'}
                  src={config.mediaEntity.get('wide_view_url')}
                  frameStyle={classes.modalIFrame}
                />
              </div>
            </Tab>
          )}
        </Tabs>
      </div>
    );
  }
};

const ModalMedia = class ModalMedia extends React.Component {
  static displayName = 'ModalMedia';
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;

    return (
      <Modal
        innerStyle={['modalStyle']}
        contentStyle={classes.availModalcontent}
        closeButtonStyle={classes.closeButton}
        modalStyle={'hotelModalStyle'}
        popover={closeMethod => <TooltipMedia theme={theme} config={config} classes={classes} langCode={this.props.langCode} resizableImages={theme.resizableImages}/>}
        typeModal={'hotelDetailTooltip'}>
        <Button innerStyle={[theme.computedInnerStyle, config.slide ? classes.buttonImageSlide : '']} icon={config.icon || { unicodeContent:config.mediaEntity.get('photos').size > 1 ? 'e043' : null}} tabIndex={-1} ariaLabel={"_%cerrar%_"} translate={true} />
      </Modal>
    );
  }
};

export default compose(
  PropertyManager(['mediaEntity', 'videoEntity', 'wideViewEntity', 'icon', 'langCode', 'slide']),
  withThemeJSS({ styleFile, styleTabs, link: true, index: 300 }, null, 'buttonImage')
)(ModalMedia);
